import { ChatMessage } from '@ant-design/pro-chat';
import CustomChatItem from '../ChatItem';
import {
  ContentObject,
  ContentObjectType,
} from '../../../interfaces/copilotChat';
import { getRecordTable } from '../../../utils/artifactUtils';
import classNames from 'classnames';

interface RecordMessageProps {
  className?: string;
  message: ChatMessage;
  result: ContentObject;
}

const RecordMessage: React.FC<RecordMessageProps> = ({
  className,
  message,
  result,
}) => {
  return (
    <div
      className={classNames(
        className,
        'artifact-message-content',
        ContentObjectType.RECORD,
        message.role
      )}
    >
      <CustomChatItem message={getRecordTable(result)} />
    </div>
  );
};

export default RecordMessage;
